function initAOS() {
  AOS.init({
    duration: 800,
    once: true,
    offset: "100%",

  });
}

document.addEventListener('DOMContentLoaded', initAOS);

new Swiper('.brx-swiper',{
    centeredSlides:true,
    spaceBetween:30,
    loop:true,
    speed: 800,
    navigation:{
    nextEl:'.brx-next',
    prevEl:'.brx-prev'
    },
    breakpoints:{
        0:{
        slidesPerView:1
        },
        1024:{
        slidesPerView:1.2
      },
       1200:{
        slidesPerView:1.7
      },
        1600:{
        slidesPerView:2.1
      }
  }  
});


document.addEventListener("DOMContentLoaded", function () {

  if(document.querySelector(".customProductSlider")){
    new Swiper(".customProductSlider", {
      spaceBetween: 20,
      loop: true,
      speed: 800,
      autoplay: {
        delay: 3000,
        disableOnInteraction: false,
      },
      pagination: {
          el: ".swiper-pagination",
          clickable: true,
      },
      
      breakpoints: {
        0: { 
          slidesPerView: 1,
          pagination: {
            enabled: true
          }
        },
        768: { 
          slidesPerView: 2,
        },
        1200: { 
          slidesPerView: 4,
          pagination: {
            enabled: false
          },
         }
      }
    });
  }

});




document.addEventListener("DOMContentLoaded", function() {

  // Select all FAQ items across both columns
  const allItems = document.querySelectorAll(".faq-item");

  allItems.forEach(item => {
    item.addEventListener("click", function() {

      // Close any other open item globally
      allItems.forEach(el => {
        if(el !== item){
          el.classList.remove("active");
          el.querySelector(".faq-answer").style.maxHeight = null;
        }
      });

      // Toggle the clicked item
      item.classList.toggle("active");
      const content = item.querySelector(".faq-answer");
      if(item.classList.contains("active")){
        content.style.maxHeight = content.scrollHeight + "px";
      } else {
        content.style.maxHeight = null;
      }
    });
  });

});


document.addEventListener("DOMContentLoaded", function() {

  const newsletterPopup = document.querySelector('.popup_newsletter');
  const cancelBtn = document.querySelector('.popup_cancel');
  const html = document.documentElement;
  const body = document.body;

  function openPopup() {
    newsletterPopup.classList.add("active");
    html.classList.add("no-scroll");
    body.classList.add("no-scroll");
  }

  function closePopup() {
    newsletterPopup.classList.remove("active");
    html.classList.remove("no-scroll");
    body.classList.remove("no-scroll");
  }

  if (window.location.pathname == "/") {
    setTimeout(() => {
      openPopup();
    }, 5000);
  }

  cancelBtn?.addEventListener("click", closePopup);

  const popupDesc = document.querySelector('.popup_newsletter-desc');
  const successMsg = document.querySelector('#Newsletter-success--popup_form');

  if(successMsg) {
      popupDesc.style.display = 'none';
  }

});